import React, { useEffect, useState } from "react";
import classNames from "classnames";

import {
  paymentMethodText,
  paymentStatusColor,
  paymentTypeColor,
  paymentAddType,
} from "_common/constants/statusType";
import moment from "moment";
import { formatNumber } from "_common/utils/formatValue";
import i18next from "i18next";
import NoData from "_common/component/NoData";

export default function ListData({ data }) {
  if (!data?.data?.length) return <NoData />;

  return (
    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
      <tbody className="text-md  divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700 md:text-base">
        {data?.data?.map((item) => (
          <tr key={item?.id} className="">
            <td className="p-2 text-white">
              <span className="text-md sm:text-base">
                {moment(item?.created_at).format("HH:mm:ss DD/MM/YYYY")}
              </span>
            </td>
            <td className="p-2 text-white">
              <span
                className={classNames(
                  "text-md sm:text-base whitespace-nowrap flex flex-col",
                  {
                    [paymentTypeColor[item?.type]]: true,
                  }
                )}
              >
                <span>
                  {item?.token?.name} - {item?.content}
                </span>
                <span className="text-white">
                  ({paymentAddType[item?.type]}){" "}
                  {formatNumber(item?.final_total, "0,0.[000000]")}{" "}
                  {item?.token?.name}
                </span>
              </span>
            </td>
            <td className="p-2 text-gray-700 md:px-6 md:py-4 dark:text-gray-300">
              <p
                className={classNames(
                  "whitespace-nowrap text-md sm:text-base",
                  {
                    [paymentStatusColor[item?.status]]: true,
                  }
                )}
              >
                {i18next.t(item?.status)}
              </p>
              {item?.reason && (
                <p className="text-sm text-red">{i18next.t(item?.reason)}</p>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
